const DEFAULT = {
    ROOT_ELEMENT: "shuttle-widget",
    TRIGGER_CLASS: "shuttle-btn",
    STYLESHEET: "https://widget.etatix.com/static/css/widget.css",
    FONTS: "https://widget.etatix.com/static/css/fonts.css",
    BRAND: "https://widget.etatix.com/static/css/brand.css",
    API: "https://widget.etatix.com/api/v1",
    PROGRAM: "default",
}

export class Config {
    constructor(scriptTag) {
        if (Config.instance != null) {
            return Config.instance;
        }
        Config.instance = this;
        this.widgetElementId = scriptTag.dataset.rootElement || DEFAULT.ROOT_ELEMENT;
        this.targetButtonClass = scriptTag.dataset.triggerClass || DEFAULT.TRIGGER_CLASS;
        this.stylesheetUrl = scriptTag.dataset.stylesheet || DEFAULT.STYLESHEET;
        this.fontsUrl = scriptTag.dataset.fonts || DEFAULT.FONTS;
        this.brandUrl = scriptTag.dataset.brand || DEFAULT.BRAND;
        this.apiUrl = scriptTag.dataset.apiUrl || DEFAULT.API;
        this.stripReturnParams = scriptTag.dataset.stripReturnParams || false;
        this.onError = scriptTag.dataset.onError;
        this.onOrderBegin = scriptTag.dataset.onOrderBegin;
        this.onOrderComplete = scriptTag.dataset.onOrderComplete;
        this.program = scriptTag.dataset.program || DEFAULT.PROGRAM;
    }

    static get(attribute) {
        return Config.instance[attribute];
    }

    static handleError(eventId) {
        const errFunction = Config.get("onError");
        if (errFunction != null && typeof window[errFunction] === "function") {
            const error = { eventId: eventId };
            const block = window[errFunction](error);
            return (block !== true);
        }
        return false;
    }
}
